import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';

export class DTO__grid2d_virtual_page {
  // calc when we get all pages to render
  page_index_absolute!: number; // in grid2d

  // calc when we get chunks_to_load_indices_range
  chunks_to_load_ids!: string[];

  // min = page_index_absolute * visible_cells_amount
  // max = Math.min(min + visible_cells_amount, total_cells_amount)
  cells_indices_to_load_range_absolute!: DTO__number_range;

  /*
   *
   */

  constructor() {
    this.chunks_to_load_ids = [];

    this.cells_indices_to_load_range_absolute = DTO__number_range.CREATE_STUB();
  }
}
